import React, { useState } from "react";
import style from "./Buttons.module.css";

export default function ButtonWithIcon(props) {
  const { defaultIcon, hoverIcon, text, btnClass = "", ...restProps } = props;
  const [icon, setIcon] = useState(defaultIcon);

  const handleMouseEnter = () => {
    setIcon(hoverIcon);
  };

  const handleMouseLeave = () => {
    setIcon(defaultIcon);
  };

  return (
    <button
      className={`${style.BtnWithIcon} ${btnClass}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...restProps}
    >
      {icon && (
        <img src={icon} alt="icon" className={`${style.BtnWithIconIMG}`} />
      )}
      <span>{text}</span>
    </button>
  );
}
